import { render, staticRenderFns } from "./AdminAuthorizeAdd.form.vue?vue&type=template&id=7a912971&"
import script from "./AdminAuthorizeAdd.form.vue?vue&type=script&lang=js&"
export * from "./AdminAuthorizeAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports